const LOGIN_REDIRECT_TIMESTAMP_KEY = 'loginRedirectTimestamp';
const LOGIN_FAILURE_LOGGED_KEY = 'loginFailureLogged';
const FAILED_LOGIN_WINDOW_MS = 60 * 1000; // 1 minute

/**
 * Checks if the user was redirected to login within the last minute.
 * Used to distinguish "Login Successful" from "Authenticated", and to detect failed logins.
 */
export function wasInitiatingSession(): boolean {
  const timestamp = localStorage.getItem(LOGIN_REDIRECT_TIMESTAMP_KEY);
  if (!timestamp) {
    return false;
  }
  const lastRedirectedToLogin = parseInt(timestamp);
  if (isNaN(lastRedirectedToLogin)) {
    return false;
  }
  return Date.now() - lastRedirectedToLogin <= FAILED_LOGIN_WINDOW_MS;
}

/**
 * Sets the login redirect timestamp to the current time.
 */
export function setLoginRedirectTimestamp(): void {
  localStorage.setItem(LOGIN_REDIRECT_TIMESTAMP_KEY, Date.now().toString());
}

/**
 * Removes the login redirect timestamp.
 */
export function clearLoginRedirectTimestamp(): void {
  localStorage.removeItem(LOGIN_REDIRECT_TIMESTAMP_KEY);
}

/**
 * Checks if a login failure has already been logged for the current session initiation.
 */
export function isFailureLogged(): boolean {
  return localStorage.getItem(LOGIN_FAILURE_LOGGED_KEY) != null;
}

/**
 * Marks that a login failure has been logged for the current session initiation.
 */
export function setFailureLogged(): void {
  localStorage.setItem(LOGIN_FAILURE_LOGGED_KEY, 'true');
}

/**
 * Clears the failure logged flag.
 */
export function clearFailureLogged(): void {
  localStorage.removeItem(LOGIN_FAILURE_LOGGED_KEY);
}
